// extracted by mini-css-extract-plugin
module.exports = {"header":"header__2qcam","description":"description__3TgH2","innerContainer":"innerContainer__3Ontv","content":"content__2-Xha"};